const React = require('react');

const CarouselSnapped = require('@andes/carousel-snapped');
const Platform = require('./components/Platform');
const { getPlatforms } = require('./platforms');

const Platforms = ({ i18n, siteId, lang, isMobile, brand }) => (
  <>
    <div className={`platforms-list platforms-background-${brand}`} id="platform-list">
      <div>
        <h1 className="platforms-list-title">{i18n.gettext('Integra nuestras soluciones para plataformas de e-commerce')}</h1>
      </div>
      <div className="platforms-list-container">
        <CarouselSnapped
          className="platforms-carrousel-container"
          scroll="hidden"
          arrows={!isMobile}
          slidesPerView={isMobile ? 3 : 7}
          pagination={brand === 'yellowblue-light' ? { mode: 'light', position: 'bottom' } : true}
        >
          {
            getPlatforms(siteId, lang).map((tool, index) => (
              <Platform {...tool} link={tool?.link || tool?.linkBySite[siteId]} i18n={i18n} index={index} isMobile={isMobile} lang={lang} brand={brand} />
            ))
          }
        </CarouselSnapped>
      </div>
    </div>
    {siteId !== 'MCO' && <span className={`platforms-finish-${brand}`} />}
  </>
);

module.exports = Platforms;
